export default "__VITE_ASSET__290e35a2__"